import { Service } from 'typedi';
import { BaseService, IBaseService, ServerResponse } from '../../../core/services/BaseService';
import { Appl } from '../../../core/Appl';
import { DeathReportModel } from './addEdit/DeathReportModel';

export interface IDeathReportService extends IBaseService {
    getDeathReportAsync(id: number): Promise<ServerResponse>;
    createDeathReportAsync(model: DeathReportModel): Promise<ServerResponse>;
}

@Service() // eslint-disable-next-line
export class DeathReportService extends BaseService implements IDeathReportService {
    constructor() {
        super(`${Appl.Setting.Services.MemberServiceUrl}`);
    }

    public async getDeathReportAsync(id: number): Promise<ServerResponse> {
        try {
            const response = await this.client.get(`/members/DeathReporting/${id}`);
            return this.getResponse(response);
        } catch (error: unknown) {
            return await this.getErrorResponse(error);
        }
    }

    public async createDeathReportAsync(model: DeathReportModel): Promise<ServerResponse> {
        try {
            const response = await this.client.post(`/members/DeathReporting`, model);
            return this.getResponse(response);
        } catch (error: unknown) {
            return await this.getErrorResponse(error);
        }
    }
}
